export default __webpack_public_path__ + "static/media/screenfour.bbc94471.jpg";